export async function callMsGraph(access_token) {
  console.log("Calling Microsoft Graph API with token:", access_token);
 
  const response = await fetch("https://graph.microsoft.com/v1.0/me", {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });
 
  return response.json();
}
 
export const getProfilePhoto = async (accessToken) => {
  console.log("Calling Microsoft Graph API with token:", accessToken);
  try {
    const res = await fetch(
      "https://graph.microsoft.com/v1.0/me/photo/$value",
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
 
    if (res.status === 404) {
      // 👈 No image uploaded
      return null;
    }
 
    if (!res.ok) {
      throw new Error("Photo fetch failed");
    }
 
    const blob = await res.blob();
    return URL.createObjectURL(blob);
  } catch (err) {
    console.error("Photo error:", err);
    return null;
  }
};